// signalr/SignalRContext.jsx
import React, { createContext, useContext, useEffect, useState } from "react";
import * as signalR from "@microsoft/signalr";
import { useSelector } from "react-redux";
import authService from "../components/api-authorization/AuthorizeService";

const SignalRContext = createContext();

export const SignalRProvider = ({ children }) => {
    const [connection, setConnection] = useState(null);
    const [isConnected, setIsConnected] = useState(false);

    // 🔁 Obtener URL desde State
    const settingsState = useSelector(state => state.settings);

    useEffect(() => {
        if (!settingsState?.settings) return;

        const options = {
            logMessageContent: true,
            logger: signalR.LogLevel.Error, //isDev ? LogLevel.Warning : LogLevel.Error,
            accessTokenFactory: async () => {
                var access = await authService.getAccessToken();
                return access;
            }
        };

        const conn = new signalR.HubConnectionBuilder()
            .withUrl(`${settingsState.settings.notificationsApi}/notificationhub`, options)
            .withAutomaticReconnect()
            .configureLogging(signalR.LogLevel.Error)
            .build();

        setConnection(conn);
    }, [settingsState]);

    useEffect(() => {
        if (!connection) return;

        const start = async () => {
            try {
                await connection.start();
                setIsConnected(true);
                console.log("✅ Conectado a SignalR");
            } catch (err) {
                console.error("❌ Error al conectar:", err);
            }
        };

        start();

        connection.onclose(() => {
            setIsConnected(false);
        });

        return () => {
            if (isConnected)
                connection.stop();
        };
    }, [connection]);

    const sendMessage = (method, ...args) => {
        if (connection?.state === "Connected") {
            return connection.invoke(method, ...args).catch(err => console.log("Error al enviar:", err));
        }
    };

    return (
        <SignalRContext.Provider value={{ connection, isConnected, sendMessage }}>
            {children}
        </SignalRContext.Provider>
    );
};

export const useSignalRContext = () => {
    const ctx = useContext(SignalRContext);
    if (!ctx) throw new Error("useSignalRContext debe usarse dentro del SignalRProvider");
    return ctx;
};
